<template>
    <div class="data-review" style="margin-top: 10px; margin-left: 30px;">
        <el-card shadow="hover">
            <div slot="header" class="clearfix">
                <span style="font-size: 18px;">数据资产审核</span>
            </div>

            <el-form label-width="120px" v-if="reviewData">
                <!-- 显示待审核数据 -->
                <!-- 基本信息 -->
                <el-form-item label="资产id">
                    <el-input v-model="reviewData.dataAssetsId" readonly></el-input>
                </el-form-item>

                <el-form-item label="资产名称">
                    <el-input v-model="reviewData.assetName" readonly></el-input>
                </el-form-item>

                <el-form-item label="数据来源">
                    <el-input v-model="reviewData.dataSource" readonly></el-input>
                </el-form-item>

                <el-form-item label="数据类型">
                    <el-input v-model="reviewData.dataType" readonly></el-input>
                </el-form-item>

                <el-form-item label="所属行业">
                    <el-input v-model="reviewData.industry" readonly></el-input>
                </el-form-item>

                <el-form-item label="数据覆盖地域">
                    <el-input v-model="reviewData.region" readonly></el-input>
                </el-form-item>

                <!-- 数据属性 -->
                <el-form-item label="数据规模类型">
                    <el-input v-model="reviewData.dataScaleType" readonly></el-input>
                </el-form-item>

                <template v-if="reviewData.dataScaleType === 'structured'">
                    <el-form-item label="表数量">
                        <el-input :value="reviewData.tableCount" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="字段数量">
                        <el-input :value="reviewData.fieldCount" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="数据条数">
                        <el-input :value="reviewData.recordCount" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="存储空间(GB)">
                        <el-input :value="reviewData.storageSize" readonly></el-input>
                    </el-form-item>
                </template>
                <template v-else-if="reviewData.dataScaleType === 'unstructured'">
                    <el-form-item label="文件数量">
                        <el-input :value="reviewData.fileCount" readonly></el-input>
                    </el-form-item>
                </template>

                <el-form-item label="数据开始时间">
                    <el-input :value="formatDate(reviewData.dataStartTime)" readonly></el-input>
                </el-form-item>
                <el-form-item label="数据结束时间">
                    <el-input :value="formatDate(reviewData.dataEndTime)" readonly></el-input>
                </el-form-item>
                <el-form-item label="更新周期">
                    <el-input v-model="reviewData.updateCycle" readonly></el-input>
                </el-form-item>

                <!-- 产权信息 -->
                <el-form-item label="权利类型">
                    <el-input :value="reviewData.rightsTypes.join(', ')" readonly></el-input>
                </el-form-item>
                <el-form-item label="产权开始时间">
                    <el-input :value="formatDate(reviewData.assetsStartTime)" readonly></el-input>
                </el-form-item>
                <el-form-item label="产权结束时间">
                    <el-input :value="formatDate(reviewData.assetsEndTime)" readonly></el-input>
                </el-form-item>
                <el-form-item label="使用限制">
                    <el-input :value="reviewData.usageLimit" type="textarea" :rows="2" readonly></el-input>
                </el-form-item>

                <!-- 文件信息 -->
                <el-form-item label="查验报告文件">
                    <el-input :value="reviewData.reportFile && reviewData.reportFile.name" readonly></el-input>
                </el-form-item>
                <el-form-item label="查验详情表">
                    <el-input :value="reviewData.verificationFile && reviewData.verificationFile.name"
                        readonly></el-input>
                </el-form-item>
                <el-form-item label="登记承诺书">
                    <el-input :value="reviewData.commitmentFile && reviewData.commitmentFile.name" readonly></el-input>
                </el-form-item>

                <!-- 审批意见 -->
                <el-form-item label="审批意见" required>
                    <el-input v-model="reviewComment" type="textarea" :rows="3" placeholder="请输入审批意见" clearable>
                    </el-input>
                </el-form-item>
            </el-form>

            <div class="review-actions">
                <el-button type="success" @click="submitPassReview()" :disabled="!reviewComment">
                    通过
                </el-button>
                <el-button type="danger" @click="submitRejectedReview()" :disabled="!reviewComment">
                    驳回
                </el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    name: "DataReview",
    data() {
        return {
            reviewData: null,
            dataAssetsId: "",
            reviewComment: "",
            loading: false
        };
    },
    created() {
        //console.log('路由参数:', this.$route.query); // 调试日志
        try {
            if (this.$route.query.formData) {
                this.reviewData = JSON.parse(this.$route.query.formData);
                // 确保所有字段都有默认值
                this.reviewData = {
                    assetName: '',
                    dataSource: '',
                    dataType: '',
                    industry: '',
                    region: '',
                    dataScaleType: 'structured',
                    tableCount: 0,
                    fieldCount: 0,
                    recordCount: 0,
                    storageSize: 0,
                    fileCount: 0,
                    dataStartTime: '',
                    dataEndTime: '',
                    updateCycle: '',
                    rightsTypes: [],
                    assetsStartTime: '',
                    assetsEndTime: '',
                    usageLimit: '',
                    reportFile: null,
                    verificationFile: null,
                    commitmentFile: null,
                    ...this.reviewData
                };
            } else if (this.$route.query.id) {
                this.loadReviewData(this.$route.query.id);
            } else {
                this.initReviewData();
            }
        } catch (error) {
            console.error('解析表单数据失败:', error);
            this.$message.error('加载审核数据失败');
            this.initReviewData();
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return '';
            return new Date(date).toLocaleDateString();
        },
        // 从接口加载审核数据
        loadReviewData(id) {
            this.loading = true;
            const user = JSON.parse(localStorage.getItem('user'));
            this.$axios.get(`/web/dataAssets/query?userId=${user.id}&dataAssetsId=${dataAssetsId}`)
                .then(response => {
                    this.reviewData = response.data;
                    // 确保所有字段都有默认值
                    this.reviewData = {
                        assetName: '',
                        dataSource: '',
                        dataType: '',
                        industry: '',
                        region: '',
                        dataScaleType: 'structured',
                        tableCount: 0,
                        fieldCount: 0,
                        recordCount: 0,
                        storageSize: 0,
                        fileCount: 0,
                        dataStartTime: '',
                        dataEndTime: '',
                        updateCycle: '',
                        rightsTypes: [],
                        assetsStartTime: '',
                        assetsEndTime: '',
                        usageLimit: '',
                        reportFile: null,
                        verificationFile: null,
                        commitmentFile: null,
                        ...this.reviewData
                    };
                })
                .catch(error => {
                    this.$message.error("获取审核数据失败: " + error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 初始化审核数据
        initReviewData() {
            if (this.$route.query.id) {
                this.loadReviewData(this.$route.query.id);
            } else {
                this.loading = true;
                this.$axios.get("/web/inti")
                    .then(response => {
                        this.reviewData = response.data;
                        // 确保所有字段都有默认值
                        this.reviewData = {
                            assetName: '',
                            dataSource: '',
                            dataType: '',
                            industry: '',
                            region: '',
                            dataScaleType: 'structured',
                            tableCount: 0,
                            fieldCount: 0,
                            recordCount: 0,
                            storageSize: 0,
                            fileCount: 0,
                            dataStartTime: '',
                            dataEndTime: '',
                            updateCycle: '',
                            rightsTypes: [],
                            assetsStartTime: '',
                            assetsEndTime: '',
                            usageLimit: '',
                            reportFile: null,
                            verificationFile: null,
                            commitmentFile: null,
                            ...this.reviewData
                        };
                    })
                    .catch(error => {
                        this.$message.error("获取审核数据失败: " + error.message);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },

        // 提交审核结果
        submitPassReview(action) {
            if (!this.reviewComment) {
                this.$message.warning("请填写审批意见");
                return;
            }

            this.loading = true;
            this.dataAssetsId = this.reviewData.dataAssetsId; // 从reviewData获取registrationId

            this.$axios.get(`/web/dataAssets/approve/pass?dataAssetsId=${this.dataAssetsId}&reviewComment=${this.reviewComment}`)
                .then(() => {
                    this.$message.success(`审核通过成功`);
                    this.$router.go(-1);
                })
                .catch(error => {
                    this.$message.error(`审核提交失败: ${error.message}`);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
        ,
        // 提交审核结果
        submitRejectedReview() {
            if (!this.reviewComment) {
                this.$message.warning("请填写审批意见");
                return;
            }

            this.loading = true;
            const payload = {
                comment: this.reviewComment,
                dataId: this.reviewData.id
            };

            this.$axios.get("/web/dataAssets/approve/rejected", payload)
                .then(() => {
                    this.$message.success(`审核驳回成功`);
                    this.$router.go(-1);
                })
                .catch(error => {
                    this.$message.error(`审核提交失败: ${error.message}`);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style scoped>
.data-review {
    padding: 20px;
}

.review-actions {
    margin-top: 30px;
    text-align: center;
}

.el-form-item__label {
    text-align: left;
    justify-content: flex-start;
}
</style>